import { render, staticRenderFns } from "./InviteCard.vue?vue&type=template&id=2afc745d&scoped=true"
import script from "./InviteCard.vue?vue&type=script&lang=js"
export * from "./InviteCard.vue?vue&type=script&lang=js"
import style0 from "./InviteCard.vue?vue&type=style&index=0&id=2afc745d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2afc745d",
  null
  
)

export default component.exports